import { PlanDetails } from '../plan';
import { SUBSCRIPTION_STATUS } from '../subscription';

export interface CreateUserParam extends UserDetails {
  password: string;
  planId?: number;
  shopId: number;
  companyLicenseKey?: string;
}

export interface UserDetails {
  uid?: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  gender: 'MALE' | 'FEMALE';
  imageUrl?: string;
  isActivated?: boolean;
  langKey?: string;
  createdBy?: string;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
  authorities?: AUTHORITY[];
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
  stripeSubscriptionStatus?: SUBSCRIPTION_STATUS;
  planId?: number;
  plan?: PlanDetails;
  shopId?: number;
  companyId?: number;
  edenredAccount?: EdenredAccountDetails;
}

export interface EdenredAccountDetails {
  id: number;
  idToken: string;
  name: string;
  email: string;
}

export enum AUTHORITY {
  GLOBAL_ADMIN = 'ROLE_GLOBAL_ADMIN',
  SHOP_ADMIN = 'ROLE_SHOP_ADMIN',
  SHOP_ORDER_ADMIN = 'ROLE_SHOP_ORDER_ADMIN',
  SHOP_RETURNABLE_ACCESSORY_ADMIN = 'ROLE_SHOP_RETURNABLE_ACCESSORY_ADMIN',
  SHOP_RESERVATION_ADMIN = 'ROLE_SHOP_RESERVATION_ADMIN',
  COMPANY_ADMIN = 'ROLE_COMPANY_ADMIN',
  MARKETPLACE_USER = 'ROLE_MARKETPLACE_USER',
}

export interface PasswordChangeParameter {
  currentPassword: string;
  newPassword: string;
}

export interface ResendActivationEmailParam {
  userEmail: string;
  shopId?: number;
}

export interface RequestPasswordResetParam {
  email: string;
  shopId?: number;
}

export interface RequestAdminPasswordResetParam {
  email: string;
}

export interface FinishPasswordResetParam {
  key: string;
  newPassword: string;
}
